import React from 'react'

export const AppContext = React.createContext({
  modal: false,
  toggleModal: () => {},
  event: false,
  triggerEvent: () => {},
})

export const withApp = Component => props => (
  <AppContext.Consumer>
    {app => <Component app={app} {...props} />}
  </AppContext.Consumer>
)